import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/cities.jpg'


const _withScopeId = n => (_pushScopeId("data-v-82b2b940"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "email-base" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Map from the game"
}, null, -1))
const _hoisted_3 = { id: "email-pop-out" }
const _hoisted_4 = { id: "mc_embed_shell" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  href: "//cdn-images.mailchimp.com/embedcode/classic-061523.css",
  rel: "stylesheet",
  type: "text/css"
}, null, -1))
const _hoisted_6 = { id: "mc_embed_signup" }
const _hoisted_7 = {
  action: "https://badtoadgames.us21.list-manage.com/subscribe/post?u=d0811a28df0dcc01a3c0700d9&id=1e72875d31&f_id=009ddde6f0",
  method: "post",
  id: "mc-embedded-subscribe-form",
  name: "mc-embedded-subscribe-form",
  class: "validate",
  target: "_blank"
}
const _hoisted_8 = {
  id: "mc_embed_signup_scroll",
  class: "email-pop-out"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<h1 id=\"newsletter_title\" data-v-82b2b940>STAY UP TO DATE</h1><input type=\"email\" name=\"EMAIL\" class=\"required email\" id=\"mce-EMAIL\" value=\"\" placeholder=\"your@email.com\" required=\"true\" data-v-82b2b940><div data-v-82b2b940><input type=\"hidden\" name=\"tags\" value=\"2857441\" data-v-82b2b940></div><div id=\"mce-responses\" class=\"clear foot\" data-v-82b2b940><div class=\"response\" id=\"mce-error-response\" style=\"display:none;\" data-v-82b2b940></div><div class=\"response\" id=\"mce-success-response\" style=\"display:none;\" data-v-82b2b940></div></div><div style=\"position:absolute;left:-5000px;\" aria-hidden=\"true\" data-v-82b2b940><input type=\"text\" name=\"b_d0811a28df0dcc01a3c0700d9_1e72875d31\" tabindex=\"-1\" value=\"\" data-v-82b2b940></div>", 5)
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Want to receive news on our progress right in your inbox? Enter your email and we'll send you our newsletter… just as soon as we teach the Toads to use keyboards. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Rest assured that we hate junk mail just as much as you, and the Toads hate having to sort it, so we will never give/sell your information to third parties without your consent. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("input", {
                type: "submit",
                name: "subscribe",
                id: "mc-embedded-subscribe",
                class: "button",
                value: "Subscribe",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createConfetti('mc-embedded-subscribe')))
              }),
              _hoisted_14
            ])
          ])
        ])
      ])
    ])
  ]))
}